import SelectAbstract from "components/SelectAbstract";
import Search from "components/Search";
import ItemClient from "components/ItemClient";

import './index.less';
import './themes/default.less';

import { ReactComponent as BuferIcon } from 'icons/pages/app/buffer.svg';

export default class ClientsSearch extends SelectAbstract {
    useTooltip = true;

    onWordChange(value) {
        clearTimeout(this.clientsTimer);

        if (value.length < 3) {
            this.items = [];
            this.openItems();
            return;
        }

        this.clientsTimer = setTimeout(() => {
            clearTimeout(this.clientsTimer);
            this.search(value);
        }, 500);
    }

    async search(value) {
        const resp = await this._request.clients.searchByNamePhone(value, 15);
        this.items = resp?.data || [];

        this.openItems();
    }

    openItems() {
        this.setOpenedState(this.items?.length > 0);
    }

    selectItem(it) {
        const items = this.getSelectedItems();

        if (items.find(info => info.id === it.id))
            return;

        const { id, fname, lname, sname, birthday, phoneNumber, photoUid } = it;

        items.unshift({ id, fname, lname, sname, birthday, phoneNumber, photoUid });

        if (items.length > 3)
            items.pop();

        this.saveStoreClients(items);

        this.setItemSelection(it.id);
    }

    removeItem(i) {
        const items = this.getSelectedItems();

        items.splice(i, 1);

        this.saveStoreClients(items);

        this.setOpenedState(false);
    }

    saveStoreClients(items) {
        const date = this._helper.date.toStr();
        this._helper.storage("apptSelectedClients", { items, date });
    }

    writeToBuffer(info, e) {
        this._helper.stopEvent(e);

        this.setOpenedState(false);

        this.props.writeToBuffer(info);
    }

    setItemSelection(id) {
        this.setOpenedState(false);

        if (this.props.onItemSelectionClick)
            this.props.onItemSelectionClick(id);
    }

    getMainStyle() {
        return "clientsSearch flex1";
    }

    insertPopupItem(it, i) {
        return (
            <ItemClient
                key={i}
                info={it}
                iconRight={<BuferIcon data-tooltip="buffer.write" onClick={this.writeToBuffer.bind(this, it)} />}
                firstRowClick={this._helper.openClient.bind(this._helper, it.id, {})}
                onClick={this.selectItem.bind(this, it)}
            />
        );
    }

    getItems() {
        return this.items || [];
    }

    getSelectedItems() {
        return this._helper.storage("apptSelectedClients")?.items || [];
    }

    renderSelector() {
        return (
            <div ref={el => this.selector = el} className="clientsSelector flex col gap8">
                <Search
                    placeHolder={"main.searchPatient"}
                    useBgStyle={false}
                    onChange={this.onWordChange.bind(this)}
                    onFocus={this.openItems.bind(this)}
                />
                <div className="selected flex gap8">
                    {this.getSelectedItems().map((it, i) => {
                        return (
                            <ItemClient
                                className="flex1"
                                key={i}
                                info={it}
                                active={this.props.selectedItem === it.id}
                                removeTooltip="client.delete"
                                removeCb={this.removeItem.bind(this, i)}
                                firstRowClick={this._helper.openClient.bind(this._helper, it.id, {})}
                                onClick={this.setItemSelection.bind(this, it.id)}
                            />
                        );
                    })}
                </div>
            </div>
        );
    }
}
